// 钱包概览只使用真实钱包字段；缺失的钱包金额保留未知态。
export function walletOverviewItems(wallets = []) {
  const find = (...types) => wallets.find(wallet => types.includes(String(wallet.walletType).toUpperCase()) && String(wallet.currency).toUpperCase() === 'CNY')
  const center = find('MAIN', 'CENTER'), locked = find('LOCKED'), welfare = find('WELFARE')
  return [
    { key:'center', label:'中心钱包', icon:'wallet', amount:center?.availableBalance ?? center?.balance ?? null, currency:center?.currency || 'CNY' },
    { key:'locked', label:'锁定钱包', icon:'lock-key', amount:locked?.availableBalance ?? locked?.balance ?? center?.frozenBalance ?? null, currency:locked?.currency || center?.currency || 'CNY' },
    { key:'welfare', label:'福利中心', icon:'gift', amount:welfare?.availableBalance ?? welfare?.balance ?? null, currency:welfare?.currency || 'CNY' },
  ]
}
export function canTransferToVenue(wallet, center) {
  return Number(wallet?.status) === 1 && Number(center?.amount) > 0 && wallet.currency === center.currency
}
